export default {
  market: {
    ranking:
      'Stock ranking for all the stocks in sectors is based on FiinGroup database',
    trend: 'Technical indicators determine price trend',
    performance: 'Performance in 2 trading days',
  },
  topMover: {
    ranking:
      'Stock ranking for all the stocks in sectors is based on FiinGroup database',
  },
  technical: {
    ratio: 'The ratio of unmatched CE/FL vol to avg. vol. 10D',
    session:
      'The number of CE/FL consecutive sessions (including current session)',
    sessionPrev: 'The maximum number of CE/FL sessions in the last 3 years.',
    ranking:
      'Stock ranking for all the stocks in sectors is based on FiinGroup database',
    nrOfCo: 'Number of cancelled orders',
    volOfCo: 'Volume of cancelled orders',
    nrOfCoBuy: 'Number of cancelled buying orders',
    nrOfCoSell: 'Number of cancelled selling orders',
    volOfCoBuy: 'Volume of cancelled buying orders',
    volOfCoSell: 'Volume of cancelled selling orders',
    volPrev: 'Trading volume of the day before',
  },
  tools: {
    ranking:
      'Stock ranking for all the stocks in sectors is based on FiinGroup database',
    value: 'Value scoring point from FiinTrade',
    growth: 'Growth scoring point from FiinTrade',
    momentum: 'Momentum scoring point from FiinTrade',
    vgm: 'VGM scoring point from FiinTrade',
  },
  strategy: {
    rankingHistory:
      'Ranking value of 5 consecutive ranking periods (including current  period)',
    trading: 'Trading stocks by the internal and organizations',
    analysisCover: 'Consensus Analysis',
    ranking:
      'Stock ranking for all the stocks in sectors is based on FiinGroup database',
    value: 'Value scoring point from FiinTrade',
    growth: 'Growth scoring point from FiinTrade',
    momentum: 'Momentum scoring point from FiinTrade',
    vgm: 'VGM scoring point from FiinTrade',
    valueStockPicks: 'Top 5 stocks which are based on Value Strategy',
    growthStockPicks: 'Top 5 stocks which are based on Growth Strategy',
    momentumStockPicks: 'Top 5 stocks which are based on Momentum Strategy',
    vgmStockPicks: 'Top 5 stocks which are based on VGM Strategy',
    leaderStockPicks: 'Top 5 leader stocks',
    pricePrev: 'Price in %{x} days ago',
    topPrev: 'The highest price in %{x} ago',
    volPrev: 'Volume in %{x} days ago',
    bottomPrev: 'The lowest price in %{x} ago',
    returnDownTrend: 'Performance in Vn-Index downtrend period in %{x} recent',
    returnRecovery: 'Performance in 5 days after Vn-index reaches a trough',
    ThreeMonths: '3 months',
    SixMonths: '6 months',
    NineMonths: '9 months',
    OneYear: '1 year',
    Recent6M: '6 months',
    Recent1Y: '1 year',
    Recent2Y: '2 years',
    Recent3Y: '3 years',
  },
};
